import {
    AssessmentSchedule,
    Contact,
} from "../../models";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    ListItemIcon,
    ListItemText,
    MenuItem
} from "@mui/material";
import {
    Location,
    ResourceNotificationSetting
} from "../../API";
import React, {
    useMemo,
    useState
} from "react";

import { AssessmentScheduleForm } from "./AssessmentScheduleForm";
import ConfirmationPrompt from "../general/ConfirmationPrompt";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DropDownMenu from "../menu/DropDownMenu";
import { EditIcon } from "../../components/icons";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useAssessments } from "../dashboard/contexts/AssessmentsContextProvider";

type AssessmentScheduleDropDownMenuProps = {
    assessmentSchedule: AssessmentSchedule;
    missedNotificationSetting?: ResourceNotificationSetting;
    associatedLocations: Array<Location>;
    contacts: Array<Contact>;
    setIsOpenCreateContactDialog: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AssessmentScheduleDropDownMenu = (props: AssessmentScheduleDropDownMenuProps) => {
    const {
        assessmentSchedule,
        associatedLocations,
        contacts,
        setIsOpenCreateContactDialog,
        missedNotificationSetting
    } = props;
    const {
        onEditScheduleSubmit,
        onDeleteAssessmentSchedule,
    } = useAssessments();

    const [isOpenEditScheduleDialog, setIsOpenEditScheduleDialog] = useState(false);
    const [isOpenDeleteScheduleDialog, setIsOpenDeleteScheduleDialog] = useState(false);

    const menuItems = useMemo(() => {
        return [
            <MenuItem
                onClick={() => {
                    setIsOpenEditScheduleDialog(true);
                }}
            >
                <ListItemIcon>
                    <EditIcon />
                </ListItemIcon>
                <ListItemText>
                    Edit
                </ListItemText>
            </MenuItem>,
            <MenuItem
                onClick={() => {
                    setIsOpenDeleteScheduleDialog(true);
                }}
                sx={{ color: "error.main" }}
            >
                <ListItemIcon sx={{ color: "inherit" }}>
                    <DeleteOutlineIcon />
                </ListItemIcon>
                <ListItemText>
                    Delete
                </ListItemText>
            </MenuItem>
        ];
    }, []);

    return (
        <>
            {onEditScheduleSubmit && onDeleteAssessmentSchedule && (
                <>
                    <DropDownMenu
                        menuIcon={<MoreVertIcon />}
                        menuItems={menuItems}
                    />
                    <Dialog
                        disableEnforceFocus
                        open={isOpenEditScheduleDialog}
                        maxWidth="md"
                    >
                        <DialogTitle>
                            Edit Schedule
                        </DialogTitle>
                        <DialogContent>
                            <Box>
                                <AssessmentScheduleForm
                                    onSubmit={onEditScheduleSubmit}
                                    onCancel={() => setIsOpenEditScheduleDialog(false)}
                                    onCompleted={() => setIsOpenEditScheduleDialog(false)}
                                    existingAssessmentSchedule={assessmentSchedule}
                                    existingAssociatedLocationIds={associatedLocations.map(location => location.id)}
                                    existingMissedAssessmentNotificationSetting={missedNotificationSetting}
                                    contacts={contacts}
                                    setIsOpenCreateContactDialog={setIsOpenCreateContactDialog}
                                />
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <ConfirmationPrompt
                        isVisible={isOpenDeleteScheduleDialog}
                        promptTitle={`Delete Schedule for ${assessmentSchedule.name}`}
                        promptMessage="Are you sure you want to delete this schedule?"
                        onCancelButtonClicked={() => {
                            setIsOpenDeleteScheduleDialog(false);
                        }}
                        onConfirmButtonClicked={() => {
                            onDeleteAssessmentSchedule(assessmentSchedule, associatedLocations);
                            setIsOpenDeleteScheduleDialog(false);
                        }}
                    />
                </>
            )}
        </>
    );
};